import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'textMask'
})
export class TextMaskPipe implements PipeTransform {

	transform(value: any, ...args: unknown[]): unknown {
		if (!value) { return; }
		const val = value.toString();
		return `${val.substring(0, 2)}******${val.substring(val.length - 2)}`;
	}

}
